"use strict";

require("core-js/modules/es6.object.define-properties");

require("core-js/modules/es6.object.freeze");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InputGroupPrepend = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styledBaseComponents = require("styled-base-components");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  margin-right: -1px;\n  & > button {\n    position: relative;\n    z-index: 2;\n  };\n  & > span,\n  & > button {\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n    &:not(:first-child) {\n      margin-left: -1px;\n      border-top-left-radius: 0;\n      border-bottom-left-radius: 0;\n    };\n  };\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var InputGroupPrepend = (0, _styledComponents["default"])(_styledBaseComponents.Div)(_templateObject());
exports.InputGroupPrepend = InputGroupPrepend;